import React from 'react';
import { Gamepad2, Twitter, DiscIcon as Discord, Linkedin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark-lighter border-t border-white/10 pt-16 pb-8" data-id="element-59">
      <div className="container mx-auto px-6" data-id="element-60">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-61">
          <div className="md:col-span-1" data-id="element-62">
            <div className="flex items-center gap-2 mb-6" data-id="element-63">
              <div className="flex items-center justify-center w-8 h-8 rounded bg-dark border border-neon-cyan/30" data-id="element-64">
                <Gamepad2 className="text-neon-cyan w-5 h-5" data-id="element-65" />
              </div>
              <span className="font-rajdhani text-xl font-bold tracking-wider text-white" data-id="element-66">
                PIXEL<span className="text-neon-cyan" data-id="element-67">KEEP</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm mb-6" data-id="element-68">
              The premier esports sponsorship matching platform. Connecting
              verified rosters with authentic brands.
            </p>
            <div className="text-sm text-gray-500" data-id="element-69">
              <p data-id="element-70">Limassol, Cyprus</p>
            </div>
          </div>

          <div data-id="element-71">
            <h4 className="font-rajdhani font-bold text-lg mb-4" data-id="element-72">Platform</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-73">
              <li data-id="element-74">
                <a href="#" className="hover:text-neon-cyan transition-colors" data-id="element-75">
                  For Teams
                </a>
              </li>
              <li data-id="element-76">
                <a href="#" className="hover:text-neon-cyan transition-colors" data-id="element-77">
                  For Brands
                </a>
              </li>
              <li data-id="element-78">
                <a href="#" className="hover:text-neon-cyan transition-colors" data-id="element-79">
                  Pricing
                </a>
              </li>
              <li data-id="element-80">
                <a href="#" className="hover:text-neon-cyan transition-colors" data-id="element-81">
                  Jersey Builder
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-82">
            <h4 className="font-rajdhani font-bold text-lg mb-4" data-id="element-83">Company</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-84">
              <li data-id="element-85">
                <a href="#" className="hover:text-neon-cyan transition-colors" data-id="element-86">
                  About Us
                </a>
              </li>
              <li data-id="element-87">
                <a href="#" className="hover:text-neon-cyan transition-colors" data-id="element-88">
                  Careers
                </a>
              </li>
              <li data-id="element-89">
                <a href="#" className="hover:text-neon-cyan transition-colors" data-id="element-90">
                  Blog
                </a>
              </li>
              <li data-id="element-91">
                <a href="#" className="hover:text-neon-cyan transition-colors" data-id="element-92">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-93">
            <h4 className="font-rajdhani font-bold text-lg mb-4" data-id="element-94">Legal</h4>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-95">
              <li data-id="element-96">
                <a href="#" className="hover:text-neon-cyan transition-colors" data-id="element-97">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-98">
                <a href="#" className="hover:text-neon-cyan transition-colors" data-id="element-99">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-100">
                <a href="#" className="hover:text-neon-cyan transition-colors" data-id="element-101">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-white/10 gap-4" data-id="element-102">
          <p className="text-sm text-gray-500" data-id="element-103">
            © 2026 Pixelkeep. All rights reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-104">
            <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-105">
              <Twitter className="w-5 h-5" data-id="element-106" />
            </a>
            <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-107">
              <Discord className="w-5 h-5" data-id="element-108" />
            </a>
            <a href="#" className="text-gray-500 hover:text-white transition-colors" data-id="element-109">
              <Linkedin className="w-5 h-5" data-id="element-110" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}